import {AbstractModel} from './abstract-model';

export class Currency extends AbstractModel {
  id: number | null = null;
  isoCode: string | null = null;

  override toString(): string {
    return this.isoCode ?? '';
  }
}
